
import { DomainSubject } from "../../eventSubjects/domainSubject";
import {SlotRenderEndedSubjectData} from "./slotRenderEndedSubject";

export class FirstSlotRenderEndedSubject extends DomainSubject<SlotRenderEndedSubjectData>{
    name="FirstSlotRenderEndedSubject";
    mustBeTriggeredOnce=true;
    
    onAfterTrigger=()=>{
        setTimeout(()=>{
            const endEvent=new CustomEvent<SlotRenderEndedSubjectData>("adRunner_SlotRenderEnded");
            dispatchEvent(endEvent);
        },6000);
    }
    init=()=>{}

}

const firstSlotRenderEndedSubject=new FirstSlotRenderEndedSubject();
firstSlotRenderEndedSubject.activate();

export {firstSlotRenderEndedSubject};